import { LoginResult, User, Tenant } from '@aksape/types';
import { apiGet, apiPost } from '~/shared/lib/api-client';

export const authApi = {
  login: (email: string, senha: string) =>
    apiPost<LoginResult>('/auth/login', { email, senha }),

  logout: () => apiPost<void>('/auth/logout'),

  refreshToken: (refreshToken: string) =>
    apiPost<{ accessToken: string; expiresAt: string }>('/auth/refresh', { refreshToken }),

  getMe: () => apiGet<{ user: User; tenant: Tenant }>('/auth/me'),

  forgotPassword: (email: string) =>
    apiPost<{ message: string }>('/auth/forgot-password', { email }),
};
